import { DeleteIcon } from "@/constant/imagePath";
import IconButton from "..";

const DeleteButton = ({
  icon = DeleteIcon,
  borderColor = "#610002",
  fromColor = "#AE1C28",
  toColor = "#780002",
  onClick = null,
  tooltipText = "Delete",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      onClick={onClick}
      tooltipText={tooltipText}
      buttonStyle={{ padding: "2.5px" }}
      {...props}
    />
  );
};

export default DeleteButton;
